import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { armyOrganisationPresenter } from '@Selectors/builder/myArmyList/make/army-organisation.presenter';
import {
  ArmyOrganisationView,
} from '@Selectors/builder/myArmyList/make/ArmyOrganisationView';

import Repeater from '@Utils/Repeater';
import classNames from 'classnames';
import { OrganisationBlock } from './army-list-organisations.styled';

const ArmyListOrganisations: React.FC<ArmyListOrganisationsProps> = ({
  organisations,
}) => {
  return (
    <div className="row justify-content-center">
      <Repeater data={organisations} indexPrefix="organisation">
        {(item: ArmyOrganisationView) => (
          <OrganisationBlock className="col-3 col-md-2 col-xl-1 p-0">
            {item.logo && (
              <img alt={item.name} src={item.logo} className="img-fluid" />
            )}
            <div className={classNames({ 'highlight-red': !item.good })}>
              {item.rate}
            </div>
          </OrganisationBlock>
        )}
      </Repeater>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  organisations: armyOrganisationPresenter(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListOrganisations);

type ArmyListOrganisationsProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
